export default "__VITE_ASSET__C0BICQaZ__"